/** Layout width tokens for expandable OData filter fields (Expandable/style.less). */
export const FILTER_FIELD_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};
